import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';

interface CampaignFlowStore {
  isFlowChanging: boolean;

  setIsFlowChanging: (newValue: boolean) => void;
}

const useCampaignFlowStore = createWithEqualityFn<CampaignFlowStore>(
  (set) => ({
    isFlowChanging: false,

    setIsFlowChanging(newValue: boolean) {
      set(() => ({ isFlowChanging: newValue }));
    },
  }),
  shallow
);

export default useCampaignFlowStore;
